"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const fluxible_router_1 = require("fluxible-router");
const GalleryStore_1 = require("../stores/GalleryStore");
const fluxible_addons_react_1 = require("fluxible-addons-react");
const helper_1 = require("../helper");
const $ = require('jquery');
class Galleries extends React.Component {
    constructor(props) {
        super(props);
        this.rigrid = React.createRef();
    }
    goToAlbum(name) {
        this.props.executeAction(fluxible_router_1.navigateAction, {
            url: '/album/' + name,
            method: 'GET',
        });
    }
    render() {
        let i = 0;
        const elemCount = 12;
        const galleries = new Array();
        if (this.props.galleriesResult.results != null) {
            for (const elem of this.props.galleriesResult.results) {
                i++;
                galleries.push({
                    _id: i,
                    heroImage: elem.heroImage,
                    name: elem.name,
                });
            }
            if (galleries.length <= elemCount) {
                let j = 0;
                while (galleries.length <= elemCount && j < elemCount) {
                    for (const elem of this.props.galleriesResult.results) {
                        if (elem.images[j] != null) {
                            i++;
                            galleries.push({
                                _id: i,
                                heroImage: elem.images[j],
                                name: elem.name,
                            });
                        }
                    }
                    j++;
                }
            }
        }
        return (React.createElement("div", null,
            React.createElement("section", { className: 'featured' },
                React.createElement("div", { className: 'ri-grid ri-grid-size-3', ref: this.rigrid },
                    React.createElement("ul", { className: 'pi-thumbs' }, galleries.map((gallery) => {
                        return (React.createElement("li", { key: gallery._id },
                            React.createElement("a", { className: 'gallery-click', "data-name": gallery.name, href: '#' },
                                React.createElement("img", { src: (0, helper_1.convertImageUrl)(addTransormation(gallery.heroImage.secure_url)) }),
                                React.createElement("div", { className: 'caption' },
                                    React.createElement("div", { className: 'inner' },
                                        React.createElement("i", { className: 'pi-plus' }),
                                        React.createElement("h4", null, gallery.name))))));
                    }))))));
    }
    componentDidMount() {
        this.startGrid($(this.rigrid.current));
    }
    componentDidUpdate() {
        this.startGrid($(this.rigrid.current));
    }
    startGrid($riGrid) {
        if ($riGrid.length > 0) {
            $riGrid.gridrotator({
                rows: 2,
                columns: 6,
                w1400: {
                    rows: 2,
                    columns: 6,
                },
                w1024: {
                    rows: 2,
                    columns: 5,
                },
                w768: {
                    rows: 3,
                    columns: 3,
                },
                w480: {
                    rows: 8,
                    columns: 1,
                },
                step: 'random',
                maxStep: 3,
                animType: 'random',
                animSpeed: 500,
                interval: 10000000,
                nochange: [],
                preventClick: false,
                resize() {
                    $riGrid.find('.pi-thumbs > li').each(function () {
                        $(this).hoverdir({
                            speed: 250,
                        });
                    });
                    let riWidth = $riGrid.find('ul li:last a').width(), riHeight = $riGrid.find('ul li:last a').height();
                    $riGrid.find('.view-all')
                        .css({
                        width: riWidth,
                        height: riHeight,
                    });
                },
                replaceItem(el) {
                    $riGrid.find('.caption', el).css({
                        left: '-100%',
                    });
                },
            });
        }
        let self = this;
        $($riGrid).on('click', '.gallery-click', function (e) {
            e.preventDefault();
            self.goToAlbum($(this).data('name'));
        });
    }
}
class GalleryProps {
}
function addTransormation(imageUrl) {
    return imageUrl
        .replace('image/upload/', 'image/upload/c_scale,w_375/');
    // .replace('jpg', 'webp');
}
exports.default = (0, fluxible_router_1.handleHistory)((0, fluxible_addons_react_1.connectToStores)(Galleries, [GalleryStore_1.default], (context, props) => {
    return {
        galleriesResult: context.getStore(GalleryStore_1.default).getEntities(),
        executeAction: context.executeAction,
    };
}));
